import Icon from "../../../components/ui/Icon";
import { NOTIF_STYLES } from "../../../styles/notificationStyles";

export default function NotificationCard({ item, onAction }) {
  const s = NOTIF_STYLES[item.severity] ?? NOTIF_STYLES.info;
  return (
    <div className={`rounded-2xl border ${s.border} ${s.bg} px-4 py-3.5 flex items-start gap-3`}>
      <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full mt-0.5 ${s.iconBg}`}>
        <Icon name={item.icon} className={`text-base ${s.iconColor}`} />
      </span>
      <div className="flex-1 flex flex-col gap-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className={`text-[10px] font-black italic tracking-widest uppercase px-1.5 py-0.5 rounded-full ${s.chipBg} ${s.chipText}`}>
            {s.chipLabel}
          </span>
          <span className="text-sm font-semibold text-brand-light">{item.title}</span>
        </div>
        <span className="text-xs text-brand-light/60">{item.body}</span>
        {item.target && (
          <button
            type="button"
            onClick={() => onAction(item.target)}
            className="flex items-center gap-1 text-xs font-semibold text-brand-magenta hover:text-brand-pink transition self-start mt-1"
          >
            {item.actionLabel ?? "View details"}
            <Icon name="arrow_forward" className="text-sm" />
          </button>
        )}
      </div>
    </div>
  );
}
